<template>
  <b-card no-body class="my-2">
    <b-card-header class="card-header-results" :class="{ selectedPdf : selected}">
      <div class="card-header-result-name">
        <b-iconstack @click="$emit('toggle')" v-b-tooltip.hover.left title=" Selecteaza PDF">
          <b-icon icon="square" stacked />
          <b-icon icon="check" v-if="selected" scale="0.9" stacked />
        </b-iconstack>
        <b-icon class="ml-2" @click="$emit('info')" icon="info-square" v-b-tooltip.hover.top title="Info">
        </b-icon>
        <b-icon @click="toggleCollapse()" :icon="collapsed ? 'dash' : 'plus'" v-b-tooltip.hover.top
          :title="collapsed ? 'mai putin' : 'mai mult'" class="mx-2" />
        <span style="font-size:16px;" @click="toggleCollapse()">
          <strong class="mr-2">{{ result.name }}</strong>
          <sup class="text-warning" v-if="starsIsNumber">
            <span v-for="star in stars" :key="star">
              <img src="@/assets/images/logos/hh-star.png" alt="" height="10px" class="ml-1">
            </span>
          </sup>
          <span v-else class="text-warning">{{ result.stars }}</span>
        </span>
        <h6 class="text-primary d-inline ml-2"><small>{{ result.extraStars }}</small></h6>
      </div>
      <div class="price-and-status">
        <span v-if="status == 'AVL'" class="FCAVL" v-b-tooltip.hover.top title="Disponibil"><b-icon icon="check-circle"
            font-scale="1.3"></b-icon></span>
        <span v-if="status == 'RQ'" class="RQNA" v-b-tooltip.hover.top title="La cerere"><b-icon icon="chat-quote"
            font-scale="1.3"></b-icon></span>
        <span v-if="status == 'N/A'" class="RQNA" v-b-tooltip.hover.top title="Indisponibil"><b-icon icon="slash-circle"
            font-scale="1.3"></b-icon></span>
        <span class="text-primary ml-2 " :class="{
          'price-full': displayedMeal.discount
}">
          <b>pret de la: {{ getFullPrice({
            meal: displayedMeal, noRooms: this.params.rooms.length, starRating:
              result.stars, fees
          }) }} {{ params.currency }}</b>
        </span>
        <span class="price-off" v-if="displayedMeal.discount">pret redus: {{ getPrice({
          meal: displayedMeal, noRooms:
            this.params.rooms.length, starRating: result.stars, fees
        }) }} {{ params.currency }}</span>
      </div>
    </b-card-header>
    <b-card-body v-if="collapsed">
      <b-row>
        <b-col md="4">
          <b-card no-body class="bg-light mb-4 mb-sm-0">
            <b-carousel id="carousel" controls indicators background="#FFF" v-if="result.images.length">
              <b-carousel-slide v-for="(image, imageIndex) in result.images" :key="imageIndex">
                <template slot="img">
                  <img :src="image.url" class="img-fluid w-100 d-block carousel-img" />
                </template>
              </b-carousel-slide>
            </b-carousel>
            <template v-else>
              <img v-if="result.image" :src="result.image.url" class="img-fluid" />
              <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
            </template>
            <b-card-text class="justify-content-center d-flex flex-column">
              <span v-if="result.url">
                <small class="text-center d-block my-4">
                  <a :href="result.url" target="_blank">{{ result.url }}</a>
                </small>
              </span>
            </b-card-text>
          </b-card>
          <!-- departure info -->
          <DepartureInfo :params="params" :result="result" :displayedMeal="displayedMeal" :fees="fees"
            v-if="params.packageType !== 'tour'" />
          <!-- {{params.packageType}} -->
          <!-- /departure info -->
        </b-col>
        <b-col md="8">
          <h4 class="border-bottom pb-2">
            <span class="mr-2">{{ result.name }}</span>
            <sup class="text-warning" v-if="starsIsNumber">
              <span v-for="star in stars" :key="star">
                <img src="@/assets/images/logos/hh-star.png" alt="" height="10px" class="ml-1">
              </span>
            </sup>
            <span v-else class="text-warning">{{ result.stars }}</span>
            <b-button variant="primary" @click="$emit('info')" size="sm" class="float-right">
              <b-icon icon="info-circle-fill" class="mr-2" /> detalii
            </b-button>
          </h4>
          <p v-if="result.descriptionIsHtml" v-html="result.description"></p>
          <p style="white-space: pre-line;" v-else>{{ result.description }}</p>
          <p v-if="params.packageType !== 'tour' && params.packageType !== 'package'">
            <small>
              <b><i>Camere in allotment cu reconfirmare in termen de 48h de la rezervare!</i></b><br />
              * Economy/Promo Rooms (sau orice alta denumire similara) – sunt camere limitate ca număr,
              au perioade de vânzare diferite și beneficiază de reduceri speciale.
              Ele oferă aceleași condiții de cazare ca restul camerelor din ofertă,
              doar că, în unele situații pot apărea anumite inconveniente cum ar fi:
              poziționarea în zone nefavorabile (de exemplu: clădiri anexe, parter, pe colț, etc.),
              pot avea dimensiuni mai mici, fără balcon sau pot avea vederea obstrucţionată.
            </small>
          </p>
          <slot></slot>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'
import DepartureInfo from './departure_info'
import model from '../../package/services/model'

export default {
  name: 'SearchResult',
  components: { DepartureInfo },
  props: {
    params: Object,
    result: Object,
    selected: Boolean,
    expanded: Boolean,
    displayedMeal: Object,
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data () {
    return {
      model,
      collapsed: this.expanded
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    getFullPrice,
    getPrice
  },
  computed: {
    starsIsNumber () {
      // Try converting the string to an integer
      const intValue = parseInt(this.result.stars, 10) // Base 10 for decimal system

      // Check if it's a valid integer and not NaN
      return !isNaN(intValue) && Number.isInteger(intValue)
    },
    stars () {
      return parseInt(this.result.stars, 10)
    },
    status () {
      let isAvl = false
      let isNa = true

      const categoriesMap = data => {
        data.categories.map(cat => {
          if (cat.hotelIsAvailable && !cat.hotelIsBlackedOut) isAvl = true
          if (!cat.hotelIsBlackedOut) isNa = false
        })
      }

      if (this.result.packages) {
        this.result.packages.map(pack => {
          categoriesMap(pack)
        })
      } else {
        categoriesMap(this.result)
      }

      if (isAvl) return 'AVL'
      else if (isNa) return 'N/A'
      else return 'RQ'
    }
  }
}
</script>
<style>
.price-full{
  text-decoration: line-through;
}
</style>
